<template>
  <div>
    <el-drawer
      title=""
      :visible.sync="showDrawer"
      :with-header="false"
      :append-to-body="true"
      :modal="false"
      :wrapperClosable="false"
    >
      <div class="addDrawerTitle">
        {{ drawerTitle }}
      </div>
      <el-form
        ref="resForm"
        :model="resForm"
        class="searchForm"
        :rules="formRules"
      >
        <el-form-item
          v-for="(item, index) in formData"
          :key="index + item.prop"
          :label="$t(item.label)"
          :prop="item.prop"
          :class="item.prop == 'urlList' ? 'heightItem' : ''"
        >
          <!-- <el-radio-group 
         v-if="item.prop==='resIconType'"
         v-model="resForm[item.prop]">
            <el-radio :label="3">已选中项</el-radio>
            <el-radio :label="6">未选中项</el-radio>
        </el-radio-group> -->
          <!-- <el-button
            v-if="item.prop == 'urlList'"
            class="yesBtn"
            @click="addUrl()"
            >新增</el-button
          > -->
          <!-- <el-button
            v-if="item.prop == 'urlList'"
            class="noBtn"
            @click="deleteUrl()"
            >删除</el-button
          > -->
          <!-- <el-table
            v-if="item.prop == 'urlList'"
            :row-key="getRowKey"
            :data="resForm.urlList"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              :reserve-selection="true"
            />
            <el-table-column
              prop="name"
              label="URL名称"
              width="250px"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.name"
                  :placeholder="$t(`common.pleaseInput`)"
                  clearable
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="value"
              label="URL"
              width="250px"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.value"
                  :placeholder="$t(`common.pleaseInput`)"
                  clearable
                >
                </el-input>
              </template>
            </el-table-column>
          </el-table> -->
          <!-- <el-input
            v-model="resForm[item.prop]"
            :placeholder="item.placeholder"
            clearable
            v-if="item.prop !== 'urlList'"
          > -->
          <el-input
            v-model="resForm[item.prop]"
            :placeholder="$t(item.placeholder)"
            clearable
            v-if="
              item.prop !== 'status' &&
              item.prop !== 'effectiveDate' &&
              item.prop !== 'expDate' &&
              item.prop !== 'org' &&
              item.prop !== 'belongSys'
            "
          >
          </el-input>
          <el-date-picker
            v-model="resForm.effectiveDate"
            type="datetime"
            :placeholder="$t(`common.selectDate`)"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-if="item.prop == 'effectiveDate'"
            :picker-options="pickerOptionsStart"
          >
          </el-date-picker>
          <el-date-picker
            v-model="resForm.expDate"
            type="datetime"
            :placeholder="$t(`common.selectDate`)"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-if="item.prop == 'expDate'"
            :picker-options="pickerOptionsEnd"
          >
          </el-date-picker>
          <!-- <el-select
            v-model="resForm[item.prop]"
            :placeholder="$t(item.placeholder)"
            clearable
            v-if="item.prop == 'belongSys'"
          >
            <el-option label="*" value="*"></el-option>
          </el-select> -->
          <el-input
            v-model="resForm[item.prop]"
            :placeholder="$t(item.placeholder)"
            clearable
            v-if="item.prop == 'belongSys'"
          ></el-input>
          <el-select
            v-model="resForm[item.prop]"
            :placeholder="$t(item.placeholder)"
            clearable
            v-else-if="item.prop == 'org'"
          >
            <el-option
              v-for="(item, index) in orgTreeData"
              :key="index"
              :label="item.details.orgName"
              :value="item.details.orgCode"
            ></el-option>
          </el-select>
          <el-select
            v-model="resForm[item.prop]"
            :placeholder="$t(item.placeholder)"
            clearable
            v-else-if="item.prop == 'status'"
          >
            <el-option :label="$t(`common.normal`)" value="N"></el-option>
            <el-option :label="$t(`common.forbid`)" value="F"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="bottomBtns" :class="addClass">
        <el-button class="yesBtn" type="primary" @click="confirm()">{{
          $t(`common.confirm`)
        }}</el-button>
        <el-button class="noBtn" @click="setDrawer(false)">{{
          $t(`common.cancel`)
        }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getOrgTree } from "@/api/authorization";
export default {
  name: "LeftDrawer",
  props: {
    drawerTitle: {
      type: String,
      default: "",
    },
    showDrawer: {
      type: Boolean,
      default: false,
    },
    drawerMode: {
      type: String,
      default: "add",
    },
    type: {
      type: String,
      default: "",
    },
    formData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    addoreditForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedUrl: [],
      resFormRules: {},
      defaultProps: {
        children: "children",
        label: "label",
      },
      api: {},
      tableType: "",
      tableData: {},
      resForm: {
        // resGroupCode: "",
        // resGroupName: "",
        // resGroupNameCn: "",
        // org: '',
        // belongSys: "*",
        // status: "",
        // effectiveDate: "",
        // expDate: "",
      },
      true: true,
      false: false,
      addClass: "",
      orgTreeData: [{ details: {} }],
    };
  },
  created() {},
  watch: {
    formData: {
      immediate: true,
      handler(val) {
        let _this = this;
        this.formRules = Object.assign(
          {},
          (function () {
            let obj1 = {};
            val.forEach((item) => {
              let obj = {};
              obj[item.prop] = [
                {
                  required: item.required,
                  message: _this.$t(`common.pleaseInput`),
                  trigger: "blur",
                },
              ];
              Object.assign(obj1, obj);
            });
            return obj1;
          })()
        );
        this.$set(this, "resForm", this.addoreditForm);
      },
    },
  },
  mounted() {
    this.queryOrgTree();
    this.$nextTick(() => {
      // this.resForm.org=this.$store.getters.user.org
      this.resForm.org = "qcc";
      // this.resForm.belongSys= "*"
      // let drawerHeight =
      //   document.getElementsByClassName("el-drawer__body")[0].scrollHeight;
      // let screenHeight = window.screen.height;
      // if (drawerHeight > screenHeight) {
      //   //按钮固定在抽屉下方
      //   this.addClass = "fixedBottom";
      // } else {
      //   this.addClass = "";
      // }
    });
    this.$set(this, "resForm", this.addoreditForm);
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
     // 开始结束日期限制
    pickerOptionsStart() {
      return {
        disabledDate: (time) => {
          if (this.resForm.expDate) {
            return (
              time.getTime() >
              new Date(this.resForm.expDate).getTime() -
                1 * 24 * 60 * 60 * 1000
            );
          }
        },
      };
    },
    // 结束日期限制
    pickerOptionsEnd() {
      return {
        disabledDate: (time) => {
          if (this.resForm.effectiveDate) {
            return (
              time.getTime() < Date.now() - 1 * 60 * 60 * 1000 ||
              time.getTime() <
              new Date(this.resForm.effectiveDate).getTime() +
                1 * 24 * 60 * 60 * 1000
            );
          }
        },
      };
    },
  },
  methods: {
    queryOrgTree() {
      getOrgTree().then((res) => {
        if (res.data) {
          this.orgTreeData = res.data || [{ details: {} }];
        }
      });
    },
    getRowKey(row) {
      return row.name;
    },
    addUrl() {
      this.resForm.urlList.push({ name: "", value: "" });
    },
    deleteUrl() {
      let arr = Uniq(this.selectedUrl, this.resForm.urlList);
      function Uniq(arr1, arr2) {
        let tempArr = arr2;
        arr1.forEach((item) => {
          for (var i = 0; i < arr2.length; i++) {
            if (arr2[i].name == item.name) {
              tempArr.splice(tempArr.indexOf(arr2[i]), 1);
            }
          }
        });
        return tempArr;
      }
      this.$set(this.resForm, "urlList", arr);
    },
    delete() {},
    // clickInput(prop){
    //     console.log('prop',prop)
    // },
    callBackAction(param) {
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      }
    },
    handleSelectionChange(val) {
      //选择待删除的url
      this.selectedUrl = val;
    },
    addResourceGroup() {
      this.$emit("addResourceGroup");
    },
    add() {},
    remove(items) {
      this.$emit("deleteResourceGroup", items.selectedItems);
    },
    setDrawer(v) {
      this.$emit("changeDrawer", v);
    },
    confirm() {
      this.$refs["resForm"].validate(() => {
        // if (valid) {
        this.$emit("addoredit", {
          form: this.resForm,
        });
        // }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bottomBtns {
  text-align: left;
  /* text-align: center;
  margin-left:-20px;
  width: 675px;
  height:60px;
  line-height:60px;
  background-color: white; */
}
.titleName {
  // font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #343c6a;
  // letter-spacing: 0;
  font-weight: 400;
}
.line {
  display: inline-block;
  height: 18px;
  width: 2px;
  background: #303133;
  margin-right: 5px;
}
.classTitle {
  height: 32px;
  line-height: 32px;
  font-size: 18px;
}
.addDrawerTitle {
  margin-bottom: 20px;
}
.fixedBottom {
  position: fixed;
  bottom: 0;
}
::v-deep .el-drawer__body {
  position: relative;
}
::v-deep .el-input__inner {
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 2px;
}
::v-deep .el-drawer__open .el-drawer.rtl {
  width: 660px !important;
}
::v-deep .el-drawer__open .el-form-item__content,
.el-select {
  width: 600px !important;
}
::v-deep .el-form-item__label {
  width: 100%;
  text-align: left;
}
.heightItem {
  height: 300px;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
